import React from 'react';

import { formatPriceByLanguage } from 'ggApp/utils/money';
import { CURRENCIES_ASSOCIATION } from 'ggApp/modules/store/constants';
import { PureTranslator } from 'ggApp/modules/translator';

import { Wrap, Image, Name, TextWrap, PlanTextWrap, PlanPrice, PlanDuration } from './styled';

const BundleProductCard = ({ className, activeStore, product, cardType }) => {
    const {
        name,
        variant: { imageUrl },
        planPrice,
        planLength,
    } = product;
    const price = formatPriceByLanguage(
        planPrice,
        CURRENCIES_ASSOCIATION[activeStore.default_currency],
        activeStore.activeLanguage,
    );

    const planTk = planLength > 1 ? 'BUNDLES_PLAN_DURATION' : 'BUNDLES_PLAN_DURATION_SHORT';

    return (
        <Wrap className={className} cardType={cardType}>
            <Image
                src={imageUrl}
                imgUrls={imageUrl}
                sizes={{
                    mobile: '50vw',
                    default: '25vw',
                }}
            />
            <TextWrap>
                <Name>{name}</Name>
                <PlanTextWrap>
                    <PlanPrice>{price}</PlanPrice>
                    <PlanDuration>
                        {planTk && (
                            <PureTranslator tk={planTk} withValues={{ duration: planLength }} />
                        )}
                    </PlanDuration>
                </PlanTextWrap>
            </TextWrap>
        </Wrap>
    );
};

export default BundleProductCard;
